import { render } from "./news-gologin.vue?vue&type=template&id=effc6ba6&scoped=true"
import script from "./news-gologin.vue?vue&type=script&lang=js"
export * from "./news-gologin.vue?vue&type=script&lang=js"

import "./news-gologin.vue?vue&type=style&index=0&id=effc6ba6&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-effc6ba6"]])

export default __exports__